import React from 'react';
import PropTypes from 'prop-types';

import {
  Link, allowListed, External, Internal
} from '@comicrelief/component-library';

import {
  Container, Wrapper, InnerWrapper, CTA
} from './BiteSize.styles';

import renderRichText from '../RichText/RichText';
import { paddingOptionMapping } from '../../utils/optionMapping';

const BiteSize = ({ data }) => {
  const {
    body, ctaLabel, ctaLink, paddingAbove, paddingBelow
  } = data;

  const isallowListed = allowListed(ctaLink);
  const target = isallowListed ? 'self' : 'blank';

  const icon = target === 'blank' ? <External colour="white" /> : <Internal colour="white" />;

  // Map the human-readable labels to the actual values, falling back to defaults:
  const paddingTop = paddingAbove ? paddingOptionMapping[paddingAbove] : '2rem';
  const paddingBottom = paddingBelow ? paddingOptionMapping[paddingBelow] : '2rem';

  return (
    <Container paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Wrapper>
        <InnerWrapper>
          {/* Will this break anything on removing Banner? */}
          {renderRichText(body, 'white', 'Banner')}
        </InnerWrapper>
        {ctaLink && ctaLabel ? (
          <CTA>
            <Link
              color="red"
              href={ctaLink}
              target={target}
              type="button"
              icon={icon}
            >
              {ctaLabel}
            </Link>
          </CTA>
        ) : null}
      </Wrapper>
    </Container>
  );
};

BiteSize.propTypes = {
  data: PropTypes.shape({
    body: PropTypes.shape({
      json: PropTypes.shape({})
    }),
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string,
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string
  }).isRequired
};

export default BiteSize;
